import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericFilter } from 'shared';
import { AvailableModulesItemCount } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'add-tenant-modules-dialog',
    templateUrl: './add-tenant-modules-dialog.component.html',
    styleUrls: ['./add-tenant-modules-dialog.component.scss'],
    standalone: false
})
export class AddTenantModulesDialogComponent implements OnInit {

  modulesForm!: UntypedFormGroup;
  availableModules: AvailableModulesItemCount[] = [];
  savedata: AvailableModulesItemCount[] = [];
  isModulesLoaded: boolean = false;
  isCreateFormCalled: boolean = false;

      get modules(): UntypedFormArray {
    return this.modulesForm.get('modules') as UntypedFormArray;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    public _dialogRef: MatDialogRef<AddTenantModulesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AvailableModulesItemCount[],
    public translate: TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService,
    //private oauthService: OAuthServiceService

  ) {

  }
   ngOnInit(): void {
    this.savedata = this.data; //vorher gebuchte Module, für Abbruch speichern
    this.isCreateFormCalled = (this.data && this.data.length > 0) ? false : true;
    this.tenantService.GetAvailableModules(this.tenantService.currentTenantName, new GenericFilter()).subscribe({
      next: (modules) => {
        console.log("-------> add-tenant-modules-dialog available modules: ", modules)
        if (!modules || modules.length === 0) { 
          this.notificationService.info(`${this.translate.data["INFO"]}`, 'Keine verfügbaren Module gefunden');
          this.isModulesLoaded = true;
          this.createForm();
          return; 
        }
        this.availableModules = modules;  
        this.availableModules.forEach(m => {
          m.count = 0;
          m.usedCount = 0;
        });
        if (this.data && this.data.length > 0) {
          this.data.forEach(bookedModule => {
            const foundModule = this.availableModules.find(m => m.moduleId === bookedModule.moduleId);
            if (foundModule) {
              foundModule.count = bookedModule.count;
              foundModule.usedCount = bookedModule.usedCount;
            } else {
              this.availableModules.push(bookedModule);
            }
          });
        }
        this.data = this.availableModules;

        this.isModulesLoaded = true;
        this.createForm();
      },
        error: (error: any) => {
          this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler beim Laden der verfügbaren Module");
          if (error.error != null) {
            this.notificationService.error(`${this.translate.data["ERROR"]}`, `${error.error}`);
          }
        }
    })           
  }

  createForm() {
    this.modulesForm = this.formBuilder.group({
      modules: this.formBuilder.array(
        this.data.map(m =>
          this.formBuilder.group({
            moduleName: [m.moduleName],
            moduleId: [m.moduleId],
            usedCount: [m.usedCount ?? 0],
            count: [
              m.count,
              [
                Validators.required,
                Validators.min(m.usedCount ?? 0)
              ]
            ],
            availableCount: [m.count !== undefined && m.usedCount !== undefined ? (m.count - m.usedCount) : 0],
          })
        )
      )    });
  }

  cancel() {
    // if (!this.isCreateFormCalled)
    //   this._dialogRef.close(this.savedata);
    // else
      this._dialogRef.close();
  }

  add() {
    //console.log("-------> add-tenant-modules-dialog before close data: ", this.modulesForm.value.modules)
    if (this.modulesForm.valid) {
      const filteredModules = this.modulesForm.value.modules.filter((m: any) => m.count > 0);
      this._dialogRef.close(filteredModules);
      // if (!this.isCreateFormCalled)
      //   this.notificationService.success(`${this.translate.data["SUCCESS"]}`, 'Module erfolgreich bearbeitet');
    }
  }
}

